/** @format */

import { CardType } from "../resources/types";

type CardTypeObject = {
  name: string;
  id: CardType;
};

export const staticCardTypes: CardTypeObject[] = [
  { name: "Read", id: "read" },
  { name: "Write", id: "write" },
  { name: "Look (Image/Video)", id: "look" },
  { name: "Listen (Sound/Audio)", id: "sound" },
  { name: "Download", id: "download" },
  { name: "Test Yourself", id: "testYourself" },
  { name: "Mark Yourself", id: "markYourself" },
  { name: "Speaking", id: "speaking" },
  { name: "Summary", id: "summary" },
  { name: "Case Study", id: "caseStudy" },
  { name: "Reflection", id: "reflection" },
  { name: "Open Opinion", id: "opinionOpen" },
  { name: "Gallery", id: "gallery" },
  { name: "Carousel", id: "carousel" },
]; /* Translate? */

export const activityCardTypes: CardTypeObject[] = [
  { name: "Multi-choice Question", id: "mcq" },
  { name: "Fill in the Blank Text (Typing)", id: "fillBlankText" },
  { name: "Select the Blank Text (Dropdown)", id: "fillBlankDropdown" },
  { name: "Sortable (Ranking)", id: "sortable" },
  { name: "True or False", id: "trueFalse" },
  { name: "Spot the Mistake", id: "spotMistake" },
  { name: "Thought Shower", id: "thoughtShower" },
  { name: "Video with Questions", id: "videoQuestion" },
  { name: "Sortable Columns (Drag & Drop)", id: "sortableColumns" },
  //{ name: "Random Question Generator", id: "randomGenerator" },
  //{ name: "Question & Answer", id: "questionAndAnswer" },
  { name: "Opinion", id: "opinion" },
  { name: "Answer the Question", id: "answerQuestion" },
]; /* Translate? */

export const getAllCardTypeIds = () => {
  const staticIds = staticCardTypes.map((card) => card.id);
  const activityIds = activityCardTypes.map((card) => card.id);
  return [...staticIds, ...activityIds];
};
